import { CapitalizeJsonKeys, CheckObjectNullValue, DelayUntil } from "../components/GlobalFunctions";
import { GlobalSetting, SecretKey } from "../components/GlobalSetting";

//Jay created 2024.01.08

const isDevMode = window.location.href.includes('localhost');

export async function GetAllOrganizers_ViaAPI(authorId) {
    let done = false;
    let success = false;
    let errorMessage = '';
    let _List = [];

    await fetch(GlobalSetting.ApiUrl
        + 'Api/LearningCentre/Organizer/List?secret=' + SecretKey.Admin + '&authorId=' + authorId,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(res => res.json())
        .then(data => {
            if (isDevMode)
                console.log(JSON.stringify(data));
            success = data.success;
            if (success) {
                if (CheckObjectNullValue(data, 'data') !== null)
                    if (Array.isArray(data.data) && Array(data.data).length > 0) {
                        _List = CapitalizeJsonKeys(JSON.parse(JSON.stringify(data.data)));
                    }
                    else {
                        if (isDevMode)
                            console.log('Organizer list is empty.');
                    }
            }
            else {
                errorMessage = data.message;
                if (isDevMode)
                    console.log('Error', 'api-organizer-load-list (failed)\n' + JSON.stringify(data));
            }
            done = true;
        })
        .catch(error => {
            if (isDevMode)
                console.log('Error', 'api-organizer-load-list (failed)\n' + error.message);
            errorMessage = error.message;
            done = true;
        });
    await DelayUntil(() => done === true);

    return { success, errorMessage, data: _List };
}

export async function UpdateOrganizer_ViaAPI(authorId, remove = false, model = null) {
    let done = false;
    let success = false;
    let errorMessage = '';
    let _List = [];

    if (model === null || typeof (model) !== 'object') {
        errorMessage = 'Invalid object.';
    }
    else {
        await fetch(GlobalSetting.ApiUrl
            + 'Api/LearningCentre/Organizer/Update',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Secret: SecretKey.Admin,
                    AuthorId: authorId,
                    Remove: remove,
                    Model: model,
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (isDevMode)
                    console.log(JSON.stringify(data));
                success = data.success;
                if (success) {
                    if (CheckObjectNullValue(data, 'data') !== null)
                        if (Array.isArray(data.data) && Array(data.data).length > 0) {
                            _List = CapitalizeJsonKeys(JSON.parse(JSON.stringify(data.data)));
                        }
                        else {
                            if (isDevMode)
                                console.log('Organizer list is empty.');
                        }
                }
                else {
                    errorMessage = data.message;
                    if (isDevMode)
                        console.log('Error', 'api-organizer-update (failed)\n' + JSON.stringify(data));
                }
                done = true;
            })
            .catch(error => {
                if (isDevMode)
                    console.log('Error', 'api-organizer-update (failed)\n' + error.message);
                errorMessage = error.message;
                done = true;
            });
        await DelayUntil(() => done === true);
    }
    return { success, errorMessage, data: _List };
}

export async function CreateOrganizer_ViaAPI(authorId, model = null) {
    let done = false;
    let success = false;
    let errorMessage = '';
    let _List = [];

    if (model === null || typeof (model) !== 'object') {
        errorMessage = 'Invalid object.';
    }
    else {
        await fetch(GlobalSetting.ApiUrl
            + 'Api/LearningCentre/Organizer/New',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Secret: SecretKey.Admin,
                    AuthorId: authorId,
                    Model: model,
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (isDevMode)
                    console.log(JSON.stringify(data));
                success = data.success;
                if (success) {
                    if (CheckObjectNullValue(data, 'data') !== null)
                        if (Array.isArray(data.data) && Array(data.data).length > 0) {
                            _List = CapitalizeJsonKeys(JSON.parse(JSON.stringify(data.data)));
                        }
                        else {
                            if (isDevMode)
                                console.log('Organizer list is empty.');
                        }
                }
                else {
                    errorMessage = data.message;
                    if (isDevMode)
                        console.log('Error', 'api-organizer-create (failed)\n' + JSON.stringify(data));
                }
                done = true;
            })
            .catch(error => {
                if (isDevMode)
                    console.log('Error', 'api-organizer-create (failed)\n' + error.message);
                errorMessage = error.message;
                done = true;
            });
        await DelayUntil(() => done === true);
    }
    return { success, errorMessage, data: _List };
}